import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import React from "react";
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Slider from "rc-slider";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import "./PdfEditArticleContainer.css";
import {
  switchZoomAction,
  noZoomAction
} from "../../redux/actions/pdfEditTocContainer";
import SinglePdfPageContainer from "../SinglePdfPageContainer/SinglePdfPageContainer";
import EditArticlePanel from "../EditArticlePanel/EditArticlePanel";
import { withCookies } from "react-cookie";
import PdfEditArticleImageList from "../PdfEditArticleImageList/PdfEditArticleImageList";
import PdfEditArticleAVList from "../PdfEditArticleAVList/PdfEditArticleAVList";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

class PdfEditArticleContainer extends React.Component {
  constructor(props) {
    super(props);
    this.renderPdfPart = this.renderPdfPart.bind(this);
    this.renderImagePart = this.renderImagePart.bind(this);
    this.renderAVPart = this.renderAVPart.bind(this);
    this.leftClicked = this.leftClicked.bind(this);
    this.rightClicked = this.rightClicked.bind(this);
    this.pageClicked = this.pageClicked.bind(this);
    this.onTabSelected = this.onTabSelected.bind(this);
    this.leftDoubleClicked = this.leftDoubleClicked.bind(this);
    this.rightDoubleClicked = this.rightDoubleClicked.bind(this);
    this.flipLeft = this.flipLeft.bind(this);
    this.flipRight = this.flipRight.bind(this);
    this.pagingBtnRefs = {};
    this.scrollPageBtns = this.scrollPageBtns.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.tagClicked = this.tagClicked.bind(this);
    this.noZoom = this.noZoom.bind(this);
    this.displayModeClicked = this.displayModeClicked.bind(this);
    this.pdfContainer = React.createRef();
    this.onDoubleClick = this.onDoubleClick.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);

    this.state = {
      leftPage: -1,
      rightPage: -1,
      pageArr: [],
      taggingMode: false,
      displayMode: false,
      activeKey: "pdf",
      sizeRange: [0, 7]
    };
  }

  scrollPageBtns() {
    const { leftPage, rightPage } = this.state;

    if (
      leftPage != null &&
      leftPage >= 0 &&
      this.pagingBtnRefs[leftPage + 1] != null
    ) {
      this.pagingBtnRefs[leftPage + 1].scrollIntoView({ behavior: "auto" });
    }

    if (
      rightPage != null &&
      rightPage >= 0 &&
      this.pagingBtnRefs[rightPage + 1] != null
    ) {
      this.pagingBtnRefs[rightPage + 1].scrollIntoView({ behavior: "auto" });
    }
  }

  componentDidMount() {
    this.setPage();
    this.pdfContainer.focus();
    this.reloadPageBtns();
    this.scrollPageBtns();
  }

  onTabSelected(selectedKey) {
    this.noZoom();
    this.setState({ activeKey: selectedKey });
  }

  noZoom() {
    this.props.noZoomAction();
  }

  onKeyDown(e) {
    if (e.key === "ArrowLeft") {
      e.view.event.preventDefault();
      this.leftDoubleClicked();
    } else if (e.key === "ArrowRight") {
      e.view.event.preventDefault();
      this.rightDoubleClicked();
    } else if (e.key === "ArrowDown") {
      e.view.event.preventDefault();
      this.displayModeClicked();
    } else if (e.key === "ArrowUp") {
      e.view.event.preventDefault();
      this.displayModeClicked();
    }
  }

  tagClicked() {
    this.setState({ taggingMode: !this.state.taggingMode, displayMode: false });
  }

  displayModeClicked() {
    this.setState({ taggingMode: false, displayMode: !this.state.displayMode });
  }

  pageClicked(page) {
    const { article, issue } = this.props;
    const { leftPage, rightPage } = this.state;

    const curLowerPage = issue.is_left_flip ? leftPage + 1 : rightPage + 1;

    if (page === curLowerPage) {
      return;
    }

    let lowerPage = page;
    let higherPage = page + 1;

    if (higherPage > article.last_page) {
      lowerPage = page - 1;
      higherPage = page;
    }

    if (issue.is_left_flip) {
      this.setState({
        leftPage: lowerPage - 1,
        rightPage: higherPage - 1
      });
    } else {
      this.setState({
        leftPage: higherPage - 1,
        rightPage: lowerPage - 1
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.issue !== prevProps.issue) {
      this.setPage();
    }

    const { article, issue } = this.props;

    if (
      (article !== prevProps.article || issue !== prevProps.issue) &&
      article != null &&
      issue != null
    ) {
      this.reloadPageBtns();
      this.scrollPageBtns();
      return;
    }

    if (
      prevState.leftPage !== this.state.leftPage ||
      prevState.rightPage !== this.state.rightPage ||
      prevState.activeKey !== this.state.activeKey
    ) {
      this.scrollPageBtns();
    }
  }

  reloadPageBtns() {
    const { article, issue } = this.props;

    if (article == null || issue == null) {
      return;
    }

    let pageArr = Array.from(
      Array(article.last_page - article.first_page + 1).keys()
    );
    pageArr = pageArr.map(page => page + article.first_page);

    if (!issue.is_left_flip) {
      pageArr = pageArr.reverse();
    }

    this.setState({
      pageArr
    });
  }

  overFlipLeft() {
    const { issue, article } = this.props;
    if (issue == null || article == null) {
      return;
    }

    const pageNum = 1;

    const { leftPage } = this.state;

    if (issue.is_left_flip) {
      let newLeftPage = parseInt(leftPage) - pageNum;

      if (newLeftPage < article.first_page - 2) {
        newLeftPage = article.first_page - 2;
      }

      const newRightPage = newLeftPage + 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    } else {
      let newLeftPage = parseInt(leftPage) + pageNum;

      if (newLeftPage > article.last_page) {
        newLeftPage = article.last_page;
      }

      const newRightPage = newLeftPage - 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    }
  }

  overFlipRight() {
    const { issue, article } = this.props;
    if (issue == null || article == null) {
      return;
    }

    const pageNum = 1;
    const { rightPage } = this.state;

    if (issue.is_left_flip) {
      let newRightPage = parseInt(rightPage) + pageNum;

      if (newRightPage > article.last_page) {
        newRightPage = article.last_page;
      }

      const newLeftPage = newRightPage - 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    } else {
      let newRightPage = parseInt(rightPage) - pageNum;

      if (newRightPage < article.first_page - 2) {
        newRightPage = article.first_page - 2;
      }

      const newLeftPage = newRightPage + 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    }
  }

  flipLeft(pageNum) {
    const { issue, article } = this.props;
    if (issue == null || article == null) {
      return;
    }

    const { leftPage } = this.state;

    if (issue.is_left_flip) {
      let newLeftPage = parseInt(leftPage) - pageNum;

      if (newLeftPage < article.first_page - 1) {
        newLeftPage = article.first_page - 1;
      }

      const newRightPage = newLeftPage + 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    } else {
      let newLeftPage = parseInt(leftPage) + pageNum;

      if (newLeftPage > article.last_page - 1) {
        newLeftPage = article.last_page - 1;
      }

      const newRightPage = newLeftPage - 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    }
  }

  flipRight(pageNum) {
    const { issue, article } = this.props;
    if (issue == null || article == null) {
      return;
    }

    const { rightPage } = this.state;

    if (issue.is_left_flip) {
      let newRightPage = parseInt(rightPage) + pageNum;

      if (newRightPage > article.last_page - 1) {
        newRightPage = article.last_page - 1;
      }

      const newLeftPage = newRightPage - 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    } else {
      let newRightPage = parseInt(rightPage) - pageNum;

      if (newRightPage < article.first_page - 1) {
        newRightPage = article.first_page - 1;
      }

      const newLeftPage = newRightPage + 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage
      });
    }
  }

  leftClicked() {
    this.overFlipLeft();
  }

  rightClicked() {
    this.overFlipRight();
  }

  leftDoubleClicked() {
    this.flipLeft(2);
  }

  rightDoubleClicked() {
    this.flipRight(2);
  }

  setPage() {
    const { issue, article } = this.props;

    if (issue == null) {
      this.setState({
        leftPage: -1,
        rightPage: -1
      });
    } else if (issue.is_left_flip) {
      this.setState({
        leftPage: article.first_page - 1,
        rightPage: article.first_page
      });
    } else {
      this.setState({
        leftPage: article.first_page,
        rightPage: article.first_page - 1
      });
    }
  }

  onDoubleClick(e) {
    if (this.pdfContainer == null) {
      return;
    }

    const { switchZoomAction } = this.props;

    const oldPos = this.pdfContainer.getBoundingClientRect();

    const oldScrollX = window.scrollX;
    const oldScrollY = window.scrollY;

    const oldMouseOffsetX = e.clientX - oldPos.x;
    const oldMouseOffsetY = e.clientY - oldPos.y;

    switchZoomAction();

    setTimeout(() => {
      const newPos = this.pdfContainer.getBoundingClientRect();
      const scale = newPos.width / oldPos.width;

      const newMouseOffsetX = oldMouseOffsetX * scale;
      const newMouseOffsetY = oldMouseOffsetY * scale;

      const newScrollX =
        oldScrollX + newMouseOffsetX - oldMouseOffsetX < 0
          ? 0
          : oldScrollX + newMouseOffsetX - oldMouseOffsetX;
      const newScrollY =
        oldScrollY + newMouseOffsetY - oldMouseOffsetY < 0
          ? 0
          : oldScrollY + newMouseOffsetY - oldMouseOffsetY;
      window.scroll(newScrollX, newScrollY);
    }, 0);
  }

  onRangeChange(sizeRange) {
    this.setState({ sizeRange });
  }

  renderPdfPart() {
    const { title, issue, article, previewingTextLineIDs } = this.props;
    const { leftPage, rightPage, pageArr, sizeRange } = this.state;

    let enablePagingLeft = false;
    let enablePagingRight = false;

    let enableSinglePagingLeft = false;
    let enableSinglePagingRight = false;

    if (issue != null && article != null) {
      if (issue.is_left_flip) {
        enablePagingRight = parseInt(rightPage) < article.last_page - 1;
        enablePagingLeft = parseInt(leftPage) > article.first_page - 1;
      } else {
        enablePagingRight = parseInt(rightPage) > article.first_page - 1;
        enablePagingLeft = parseInt(leftPage) < article.last_page - 1;
      }

      if (issue.is_left_flip) {
        enableSinglePagingRight = parseInt(rightPage) <= article.last_page - 1;
        enableSinglePagingLeft = parseInt(leftPage) >= article.first_page - 1;
      } else {
        enableSinglePagingRight = parseInt(rightPage) >= article.first_page - 1;
        enableSinglePagingLeft = parseInt(leftPage) <= article.last_page - 1;
      }
    }

    return (
      <React.Fragment>
        <Row className="pdf_utility_section">
          <Col xs="12" sm="12" md="12" lg="6" xl="auto">
            <ButtonGroup className="article_paging_btns" variant="info">
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enablePagingLeft}
                onClick={this.leftDoubleClicked}
              >
                <span className="fa fa-angle-double-left" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enableSinglePagingLeft}
                onClick={this.leftClicked}
              >
                <span className="fa fa-angle-left" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enableSinglePagingRight}
                onClick={this.rightClicked}
              >
                <span className="fa fa-angle-right" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enablePagingRight}
                onClick={this.rightDoubleClicked}
              >
                <span className="fa fa-angle-double-right" />
              </Button>
            </ButtonGroup>
            <Button
              variant={this.state.taggingMode ? "warning" : "info"}
              className="article_tag_btn"
              onClick={this.tagClicked}
            >
              <span className="fa fa-tag" />
            </Button>
            <Button
              variant={this.state.displayMode ? "warning" : "info"}
              className="article_tag_btn"
              onClick={this.displayModeClicked}
            >
              <span className="fa fa-square" />
            </Button>
          </Col>
          <Col xs="12" sm="12" md="12" lg="6" xl="3">
            <div className="article_range_slider">
              <Range
                min={0}
                max={20}
                step={0.1}
                defaultValue={[sizeRange[0], sizeRange[1]]}
                tipFormatter={value => `${value}`}
                onChange={sizeRange => this.onRangeChange(sizeRange)}
              />
              <p style={{ color: "grey" }} align="center">
                Small Text Warning
              </p>
            </div>
          </Col>
          <Col xs="12" sm="12" md="12" lg="6" xl="6">
            <ButtonGroup
              className="article_paging_btns article_page_num_btns"
              variant="info"
            >
              {pageArr.map(page => {
                const previewing =
                  previewingTextLineIDs[issue.pages[page - 1].id] != null;
                return (
                  <Button
                    key={page}
                    ref={ref => (this.pagingBtnRefs[page] = ref)}
                    variant={
                      page - 1 === leftPage || page - 1 === rightPage
                        ? "dark"
                        : "secondary"
                    }
                    className="toc_paging_btn"
                    style={{
                      color: previewing ? "limegreen" : "white",
                      fontWeight: previewing ? "bold" : "normal"
                    }}
                    onClick={() => this.pageClicked(page)}
                  >
                    {page}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Col>
        </Row>
        <div
          onDoubleClick={this.onDoubleClick}
          onKeyDown={this.onKeyDown}
          tabIndex="0"
          ref={el => (this.pdfContainer = el)}
        >
          <Row>
            <Col xs="12" sm="12" md="12" lg="6" xl="6">
              <SinglePdfPageContainer
                title={title}
                issue={issue}
                isLeft={true}
                inToc={false}
                taggingMode={this.state.taggingMode}
                displayMode={this.state.displayMode}
                page={
                  leftPage <= article.last_page - 1 &&
                  leftPage >= article.first_page - 1
                    ? leftPage
                    : -1
                }
                sizeRange={sizeRange}
              />
            </Col>
            <Col xs="12" sm="12" md="12" lg="6" xl="6">
              <SinglePdfPageContainer
                title={title}
                issue={issue}
                isLeft={false}
                taggingMode={this.state.taggingMode}
                displayMode={this.state.displayMode}
                inToc={false}
                page={
                  rightPage <= article.last_page - 1 &&
                  rightPage >= article.first_page - 1
                    ? rightPage
                    : -1
                }
                sizeRange={sizeRange}
              />
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }

  renderImagePart() {
    const { article, issue } = this.props;
    const { leftPage, rightPage, pageArr, activeKey } = this.state;

    return (
      <PdfEditArticleImageList
        article={article}
        activeKey={activeKey}
        issue={issue}
        pageArr={pageArr}
        leftPage={leftPage}
        rightPage={rightPage}
        pageClicked={this.pageClicked}
        leftDoubleClicked={this.leftDoubleClicked}
        rightDoubleClicked={this.rightDoubleClicked}
        leftClicked={this.leftClicked}
        rightClicked={this.rightClicked}
      />
    );
  }

  renderAVPart() {
    const { article } = this.props;

    return <PdfEditArticleAVList article={article} isPdf={true} />;
  }

  render() {
    const { issue, article, components } = this.props;

    return (
      <React.Fragment>
        <Tabs
          transition={false}
          onSelect={this.onTabSelected}
          activeKey={this.state.activeKey}
        >
          <Tab eventKey="pdf" title="Pdf">
            {this.renderPdfPart()}
          </Tab>
          <Tab eventKey="image" title="Image">
            {this.renderImagePart()}
          </Tab>
          <Tab eventKey="av" title="AV">
            {this.renderAVPart()}
          </Tab>
        </Tabs>
        {issue != null && article != null && (
          <EditArticlePanel
            issue={issue}
            article={article}
            isPdf={true}
            components={components}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapDispatch = {
  switchZoomAction,
  noZoomAction
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { mode, previewingTextLineIDs } = editArticlePanel;

  return {
    mode,
    previewingTextLineIDs:
      previewingTextLineIDs == null ? {} : previewingTextLineIDs
  };
};

export default withCookies(
  connect(
    mapState,
    mapDispatch
  )(PdfEditArticleContainer)
);
